import api from '../api';

export const matchesFetchSuccess = (matches) => {
    return {
        type: 'MATCHES_FETCH_SUCCESS',
        matches
    };
};

export function loadMatches() {
    return (dispatch) => {
        return api.getMatches().then(response => {
            dispatch(matchesFetchSuccess(response));
        }).catch(error => {
            throw(error);
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/matchActions.js